import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cd8997a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "i-label"
}
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.shouldDisplayLabel)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["i-label__content", _ctx.likelihood.toLowerCase()]),
          title: _ctx.likelihoodTooltip,
          style: _normalizeStyle({fontSize: `${_ctx.size}px`})
        }, _toDisplayString(_ctx.title), 15, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}